/*
 * @Author: guoguo ybbhai@hotmail.com
 * @Date: 2023-09-25 16:26:30
 * @LastEditors: guoguo ybbhai@hotmail.com
 * @LastEditTime: 2023-12-04 21:03:43
 * @FilePath: \web\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
import router from '../router'
import global from '../utils/global'

// let is_baseURL = global.baseURL // 测试环境
// 创建axios实例
const request = axios.create({
  baseURL: global.baseURL
})
// response服务器响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code == 401) {
      //清空token
      window.sessionStorage.clear()
      //跳转到登录页
      router.push('/login')
    }
    return res
  },
  error => {
    console.log('err', error)
  }
)

request.defaults.withCredentials = true
request.interceptors.request.use(config => {
  config.headers.Authorization = window.sessionStorage.getItem('token')
  config.headers.accessToken = window.sessionStorage.getItem('accessToken')
  return config
})

export default request
